// Scope Space to a focused Story passage, never an input, nested button, or
// transcript selection. Browser keyup/repeats must not restart long previews.
export function isStoryPassageSpace(event,card){
 if(!event || event.target!==card)return false;
 if(event.code!=='Space' && event.key!==' ' && event.key!=='Spacebar')return false;
 return !(event.repeat || event.ctrlKey || event.metaKey || event.altKey ||
          event.shiftKey || event.isComposing || event.nativeEvent?.isComposing);
}

// Start Assembly playback at the focused passage and continue in edit order.
// Single-passage auditions and source interview playback are unaffected.
export function assemblyFromPassage(blocks,passageId){
 if(!Array.isArray(blocks))return [];
 const index=blocks.findIndex(item=>item.id===passageId);
 return index<0?[]:blocks.slice(index);
}
